
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/leadership/senior-staff",
      function () {
        return require("private-next-pages/about/leadership/senior-staff/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/leadership/senior-staff"])
      });
    }
  